var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileTypeImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 30H21.5C22.8807 30 24 28.8807 24 27.5V9.62018C24 8.94933 23.7304 8.30663 23.2518 7.83656L16.0021 0.71638C15.5347 0.257247 14.9056 0 14.2504 0H2.5C1.11929 0 0 1.11929 0 2.5V27.5C0 28.8807 1.11929 30 2.5 30Z",
    fill: "#003393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1225 25H4.98617C4.57672 25 4.34085 24.5348 4.58284 24.2045L7.92336 19.6451C8.10408 19.3984 8.46192 19.3703 8.67894 19.5857L10.4941 21.3876C10.7201 21.6119 11.0955 21.5706 11.2673 21.3026L14.229 16.6827C14.4299 16.3694 14.8904 16.3775 15.0801 16.6976L19.5527 24.2451C19.7502 24.5784 19.5099 25 19.1225 25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.5C11 14.8807 9.88071 16 8.5 16C7.11929 16 6 14.8807 6 13.5C6 12.1193 7.11929 11 8.5 11C9.88071 11 11 12.1193 11 13.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTypeImage);
export default __webpack_public_path__ + "static/media/file-type-image.59f8c445d5e94031f4d22852ac77dc89.svg";
export { ForwardRef as ReactComponent };